/**
 *
 * App Theme.
 *
 * Extract our Sass variables into a JS object:
 * https://medium.com/styled-components/getting-sassy-with-sass-styled-theme-9a375cfb78e8
 *
 */

// eslint-disable-next-line import/no-webpack-loader-syntax
import theme from 'sass-extract-loader?{"plugins":["sass-extract-js"]}!./theme.scss';

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js